import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './lib/context/AuthContext';
import App from './App';
import './index.css';

console.log('🚀 main.tsx loading...');
console.log(
  '🌐 Supabase URL:',
  import.meta.env.VITE_SUPABASE_URL ? '✅ Found' : '❌ Missing'
);

if (
  !import.meta.env.VITE_SUPABASE_URL ||
  !import.meta.env.VITE_SUPABASE_ANON_KEY
) {
  console.error('❌ Missing Supabase environment variables');
  throw new Error('Missing Supabase environment variables');
}

console.log('📦 Mounting React app...');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

console.log('✅ React app mounted successfully');
